import Swiper, { Navigation, Pagination } from 'swiper';

export const initHomePageSlider = () => {
    new Swiper('.hero-slider .swiper-container', {
        modules: [Navigation, Pagination],
        autoplay: {
            delay: 5000,
        },
        speed: 400,
        // No loop: Swiper clones the slides for looping, which duplicated the slide's H1 (2026-10-14).
        effect: 'fade',
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        paginationClickable: true,
        grabCursor: true,
        navigation: {
            nextEl: '.hero-slider__nav-button--next',
            prevEl: '.hero-slider__nav-button--prev',
        },
    });
};

export const initEmployeeSlider = () => {

    const swiper = new Swiper('.swiper', {
        modules: [Navigation],
        // Optional parameters
        //direction: 'vertical',
        loop: true,

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

    });
};

export const initHeroSlider = () => {


};

export const initGalleryElementCarousel1 = () => {
	document.querySelectorAll('.js-gallery-element-carousel1').forEach(function (carousel) {
		new Swiper(carousel, {
            modules: [Navigation, Pagination],
			speed: 400,
			slidesPerView: 1,
            navigation: {
                nextEl: carousel.parentNode.querySelector('.js-gallery-element-carousel1-next'),
                prevEl: carousel.parentNode.querySelector('.js-gallery-element-carousel1-prev'),
            },
		});
	});
};

export const initGalleryElementCarousel2 = () => {
    document.querySelectorAll('.js-gallery-element-carousel2').forEach(function (carousel) {
        new Swiper(carousel, {
            modules: [Navigation, Pagination],
            speed: 400,
            spaceBetween: 8,
            slidesPerView: 1.5,
            navigation: {
                nextEl: carousel.parentNode.querySelector('.js-gallery-element-carousel2-next'),
                prevEl: carousel.parentNode.querySelector('.js-gallery-element-carousel2-prev'),
            },
            breakpoints: {
                639: {
                    slidesPerView: 3.5
                },
                1023: {
                    slidesPerView: 4.5
                }
            }
        });
    });
};


export const initShortcutSlider = () => {
	document.querySelectorAll('.js-shortcut-slider').forEach(function (carousel) {
		new Swiper(carousel, {
            modules: [Navigation],
			spaceBetween: 16,
			slidesPerView: 1.25,
            watchSlidesProgress: true,
            preventClicks :true,
            a11y: false,
			breakpoints: {
				639: {
					slidesPerView: 2.25
				},
				1023: {
					slidesPerView: Number(carousel.dataset.slidesLarge) || 3
				}
			},
            // Scoped to this slider, so more sliders on a page don't move each other
            navigation: {
                nextEl: carousel.querySelector('.shortcut-slider__nav-button--next'),
                prevEl: carousel.querySelector('.shortcut-slider__nav-button--prev'),
            },
		});
	});
};
